import React from 'react';
import PropTypes from 'prop-types';

import { Wrapper, Text, Actions, MessageBanner, Close } from './styles.js';
import Button from '@spa/shared/components/Unisystem/Button';
import { CloseIcon } from '@spa/shared/svg/close';

const StatusBanner = ({
  message,
  icon,
  isMobile,
  action = null,
  color,
  type = 'compact',
  isFixed,
  animate,
  hasClose,
  onClose
}) => (
  <Wrapper color={color} type={type} isMobile={isMobile} isFixed={isFixed} animate={animate}>
    <MessageBanner type={type}>
      {icon ? icon : null}
      <Text color={color} type={type} dangerouslySetInnerHTML={{ __html: message }} />
      {hasClose ? (
        <Close>
          <CloseIcon width={18} height={18} onClick={onClose} />
        </Close>
      ) : null}
    </MessageBanner>
    {action ? (
      <Actions>
        <Button isGhost onClick={onClose}>
          {action.cancel.message}
        </Button>
        <Button isSecondary onClick={action.confirm.onClick}>
          {action.confirm.message}
        </Button>
      </Actions>
    ) : null}
  </Wrapper>
);

StatusBanner.propTypes = {
  message: PropTypes.string.isRequired,
  icon: PropTypes.node,
  isMobile: PropTypes.bool,
  action: PropTypes.object,
  onClose: PropTypes.func,
  color: PropTypes.string,
  type: PropTypes.oneOf(['compact', 'text']),
  hasClose: PropTypes.bool,
  isFixed: PropTypes.bool,
  animate: PropTypes.bool
};

export default StatusBanner;
